import { render, staticRenderFns } from "./EditRepeatableEvent.vue?vue&type=template&id=2d5c40f7&"
import script from "./EditRepeatableEvent.vue?vue&type=script&lang=ts&"
export * from "./EditRepeatableEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports